import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./context/AuthProvider";

/**
 * Aguarda o boot do MSAL; se não autenticado, envia para /login preservando a rota.
 */
export default function ProtectedRoute({ children }) {
  const { isAuthenticated, booting } = useAuth();
  const location = useLocation();

  // Enquanto carrega sessão/token, não redirecione (evita cair na Home no F5)
  if (booting) return null; // ou seu <Splash/>

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
